<template>
  <div class="rounded-xl my-2">
    <Create-Post-Sidebar
      :isSidebarActive="openCreatePostSidebar"
      @closeSidebar="toggleCreatePostSidebar"
    />
    <div class="">
      <img src="../img/oops.png" alt="oops" class="w-2/5 mx-auto my-6 pt-4" />
      <div class=" cust-textmuted text-center mt-10">
        <span class="font-bold text-2xl">Whoops! </span>
        <span class="text-2xl"> Looks like there's no data.</span>
        <p class="text-xl font-normal mt-2">Be the first to post</p>
        <base-button
          type="primary"
          class="flex px-16 mt-10 mx-auto"
          @click="createPost"
        >
          Create Post
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import CreatePostSidebar from "@/layout/main/components/navbar/components/CreatePostSidebar";
export default {
  components: {
    CreatePostSidebar
  },
  data() {
    return {
      openCreatePostSidebar: false,
      openAddChannelSidebar: false
    };
  },
  methods: {
    createPost() {
      this.toggleCreatePostSidebar(true);
    },
    toggleCreatePostSidebar(val = false) {
      this.openCreatePostSidebar = val;
    }
  }
};
</script>
